import React from "react";
import { MessageCircle, Heart } from "lucide-react";

const TopFansWidget = () => {
  // Mock data - in real app, fetch from CRM/Engagement API
  const fans = [
    { id: 1, name: "Helen B.", avatar: "Alert", score: 98, status: "online" },
    { id: 2, name: "Yared T.", avatar: "YT", score: 92, status: "offline" },
    { id: 3, name: "Saron K.", avatar: "SK", score: 89, status: "online" },
  ];

  return (
    <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-100">
      <h3 className="text-sm font-bold text-slate-700 uppercase mb-3 flex items-center justify-between">
        <span>Top Superfans</span>
        <Heart size={14} className="text-red-500" fill="currentColor"/>
      </h3>
      <div className="space-y-3">
        {fans.map((fan) => (
          <div key={fan.id} className="flex items-center justify-between group">
            <div className="flex items-center gap-3">
              <div className="relative">
                <div className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center text-xs font-bold text-slate-600 border border-slate-200">
                   {fan.name.charAt(0)}
                </div>
                {fan.status === "online" && (
                    <span className="absolute bottom-0 right-0 w-2.5 h-2.5 bg-green-500 border-2 border-white rounded-full"></span>
                )}
              </div>
              <div>
                  <div className="text-sm font-medium text-slate-800">{fan.name}</div>
                  <div className="text-[10px] text-slate-400 font-medium">Top {100 - fan.score}%</div>
              </div>
            </div>
            <button className="text-slate-300 hover:text-purple-600 transition-colors p-1 rounded-full hover:bg-purple-50">
                <MessageCircle size={16} />
            </button>
          </div>
        ))}
      </div>
      <button className="w-full mt-3 py-1.5 text-xs font-medium text-purple-600 hover:text-purple-700 border border-purple-100 rounded-lg hover:bg-purple-50 transition-colors">
          View All Fans
      </button>
    </div>
  );
};

export default TopFansWidget;
